import router, { resetRouter } from './router';
import Nprogress from 'nprogress'; // Progress 路由进度条
import 'nprogress/nprogress.css';
import { UserModule } from '@/store/modules/user';
import { Route } from 'vue-router';
import { PermissionModule } from '@/store/modules/permission';
import { Message } from 'element-ui';
import i18n from '@/lang'; // Internationalization
import { getStuDataApi } from '@/api/student-management'
import { addGearUserShortcutMenuApi } from '@/api/index'

let hasRoot = false;
let isAdmin = false;
const whiteList = ['/login']; // 不重定向白名单
router.beforeEach(async (to: Route, _: Route, next: any) => {
  // gear是否显示layout布局中的tabs组件
  if (to.meta && to.meta.showIndexTabs) {
    UserModule.setIndexTabsShow(true);
  } else {
    UserModule.setIndexTabsShow(false);
  }
  Nprogress.start();
  // bms携带currentTimeMillis（时间戳）、userId（用户ID）、userPwd（用户临时密钥）
  if(to.query && !isNaN(Number(to.query.id)) && to.query.id && to.query.p && to.query.tmillis && to.query.fkCompanyId) { // bms一键进入新issue
    try {
      const params: any = {
        username: Number(to.query.id),
        password: to.query.p,
        currentTimeMillis: to.query.tmillis,
        fkCompanyId: to.query.fkCompanyId,
        bmsLoginId: to.query.bmsLoginId,
      }
      const data = await UserModule.Login(params);
      if (data && data === '10091') {
        next({ path: '/login', query: to.query as any });
        Message({
          type: 'error',
          message: i18n.t('login.accountExpired') as string,
          offset: 100
        });
        return;
      }
      if (!hasRoot) {
        UserModule.GetIssueRoot();
        hasRoot = true;
      }
      await UserModule.GetUser();
      const roles = UserModule.resourceKeys;
      if ((roles && roles.length > 0)) {
        PermissionModule.GenerateRoutes(roles);
        router.addRoutes(PermissionModule.dynamicRoutes);
        if (to.query.type === 'viewform' && to.query.stuid && !isNaN(Number(to.query.stuid))) {
          try {
            const { data } = await getStuDataApi(Number(to.query.stuid), to.query.source+'')
            const stu = `${data.data.lastName} ${data.data.firstName}`;
            next({ name: 'studentApplicationForm', params: { stuid: to.query.stuid, stu } });
          } catch (error) {
            //
          }
        } else {
          next({ path: '/index' });
        }
      } else {
        Message.error((i18n.t('common.noPermission') as string));
      }
      Nprogress.done();
    } catch (err) {
      next({ path: '/login', query: to.query as any });
    }
  // bms一键创建新issue改变方式,不需要如下方式：携带邀请码让用户自行注册
  // else if (to.query && to.query.type === 'create' && to.query.invitcode) { // bms一键创建新issue账号
  //   await UserModule.ResetToken();
  //   next({ path: '/login', query: { invitcode: to.query.invitcode } });
  //   NProgress.done();
  // }
  } else if (UserModule.token) {
    if (!hasRoot) {
      UserModule.GetIssueRoot();
      hasRoot = true;
    }
    if (to.path === '/login') {
      next({ path: '/' });
      Nprogress.done();
    } else {
      let roles = UserModule.resourceKeys;
      const hasRoles = roles && roles.length > 0;
      if (hasRoles || (isAdmin)) {
        next();
      } else {
        console.log('to', to)
        await UserModule.GetUser();
        roles = UserModule.resourceKeys;
        if ((roles && roles.length > 0)) {
          PermissionModule.GenerateRoutes(roles);
          router.addRoutes(PermissionModule.dynamicRoutes);
          next({ ...to, replace: true });
        } else {
          Message.error((i18n.t('common.noPermission') as string));
        }
      }
      Nprogress.done();
    }
  } else {
    isAdmin = false;
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next({ path: '/login', query: to.query as any });
      Nprogress.done();
    }
  }
  Nprogress.done();
});

const checkPromise = (roles: string[], metaRoles: string[]) => {
  if (metaRoles && metaRoles.length) {
    const hasRoles = roles.some((role) => metaRoles.includes(role));
    return hasRoles;
  }
  return true;
}

const menus = [
  'applicationFee', 'applicationList' , 'businessOverview', 'businessStatistics', 'contactPerson',
  'financialSettlement', 'institutionInfo', 'commissionManagement', 'setting', 'studentQuery', 'studentRegister', 'resourceManagement'
]

router.afterEach((to: Route) => {
  const menuName = to.name as string;
  if (menus.includes(menuName)) {
    const resourceKey = to.meta.roles[0];
    addGearUserShortcutMenuApi([{ menuName, resourceKey }]).then((res) => {
      console.log(res);
    })
  }
  Nprogress.done();
});
